export default __webpack_public_path__ + "afc7a3764d56c93d7650af96b6284505.svg";